import { render, staticRenderFns } from "./PanelContentCampaignCart.vue?vue&type=template&id=a85489c6&scoped=true&"
import script from "./PanelContentCampaignCart.vue?vue&type=script&lang=ts&"
export * from "./PanelContentCampaignCart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85489c6",
  null
  
)

export default component.exports